import { render, staticRenderFns } from "./add_jifen.vue?vue&type=template&id=021255a9&scoped=true&"
import script from "./add_jifen.vue?vue&type=script&lang=js&"
export * from "./add_jifen.vue?vue&type=script&lang=js&"
import style0 from "./add_jifen.vue?vue&type=style&index=0&id=021255a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021255a9",
  null
  
)

export default component.exports